import { API_BASE_URL } from '../../common/constants';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { getHeaders } from './helpers';
import { axiosResponseHandler } from '../CloudFunctionsService';

class Account {
  /**
   *
   */
  async remove(userId: string, accountId: string) {
    const response = axios.post(
      API_BASE_URL + '/accountRemove',
      {
        userId: userId,
        accountId: accountId,
      },
      { headers: getHeaders() },
    );
    return axiosResponseHandler(response);
  }
}

export default Account;
